module.exports = __webpack_public_path__ + "static/media/microphone-slash.062892eb.svg";